import styled from "styled-components";
export const SearchContainer = styled.div`
  .type-ahead-search-input {
    position: relative;
    border-radius: 4px;
    margin: 0;
    display: flex;
    align-items: center;
    height: 100%;
    .dropdown-menu {
      box-shadow: rgba(245, 205, 205, 0.08);
      border-color: $lightGrey;
      padding: 0;
      margin-top: 5px;
      border-radius: 0;
      .dropdown-item {
        padding: 12px 16px;
        &:hover,
        &:active,
        &.active {
          background-color: #545b62;
          color: #fff;
        }
      }
    }
    .button-search {
      position: relative;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
      margin: 0;
      display: flex;
      align-items: center;
      height: 100%;
      border: 1px;
      background: #52769d;
    }
    .seacrh-icon {
      max-width: 41px;
      height: 41px;
      margin-left: 13px;
      border-radius: 3.3px;
      padding: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
    > div {
      width: 100%;
      flex: 1;
      height: 100%;
      input {
        /* height: 44px; */
        width: 100%;
        padding-right: 42px;
        border: 1px solid $lightGrey;
        border-radius: 6px;
        &::-webkit-input-placeholder {
          color: $lightGrey;
        }

        &:-ms-input-placeholder {
          color: $lightGrey;
        }

        &::placeholder {
          color: $lightGrey;
        }
        &:focus {
          outline: none;
          border-color: $lightGrey;
          box-shadow: none;
        }
      }
    }
    @media (max-width: 767px) {
      .dropdown-menu {
        box-shadow: rgba(245, 205, 205, 0.08);
        border-color: $lightGrey;
        padding: 0;
        margin-top: 5px;
        border-radius: 0;
        min-width: 235px;
        .dropdown-item {
          padding: 9px 13px;
          font-size: 14px;
        }
      }
    }
  }

  .search-input-transparent {
    input {
      background: transparent;
      &:focus {
        background: transparent;
      }
    }
  }
`;
